import React from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';

function MemberPage() {
  const { t } = useTranslation();
  return (
    <div className="membersetup">
      {t(
        'memberpage.empty',
        'Welcome to our experimental membership area. This feature is currently in testing. See you soon!'
      )}
    </div>
  );
}

export default MemberPage;
